module.exports = __webpack_public_path__ + "img/concrete-hole-decal-28.1b9a4c3b.png";